<template>
  
  <div :id="_uid" class="ui small modal" :class="modalSelector">
    <div class="ui header">
      Filtrar Animais
    </div>
    <div class="content">
      <div class="ui form" :class="{ loading }">
        <div class="fields">          
          <div class="sixteen wide field">
            <label class="form-label">Animal</label>
            <input v-model="filter.animalName">
          </div>                         
        </div>
        <div class="fields">
          <div class="sixteen wide field">
            <label class="form-label">Tutor</label>
            <input v-model="filter.ownerName">
          </div>          
        </div>
      </div>
    </div>
    <div class="actions">
      <button class="ui cancel basic button">
        <i class="times icon"></i> Sair
      </button>      
      <button v-if="showRemoveButton" class="ui teal basic button" @click="onRemove()">
        <i class="undo icon"></i> Remover
      </button>      
      <button class="ui blue button" :class="{ disabled: !canApply }" @click="onApply()">
        <i class="checkmark icon"></i> Aplicar
      </button>
    </div>
  </div>

</template>

<script>

  import AnimalService from "@/services/animal-service"
  import modalDialog from "@/mixins/modal-dialog"

  export default {
    
    name: "AnimalsFilterModal",

    mixins: [modalDialog],

    data() {
      return {
        filter: {},
        showRemoveButton: false,
      }
    },

    computed: {

      canApply() {
        
        const { animalName, ownerName } = this.filter

        return (animalName || ownerName)
      },
    },

    methods: {      

      onShow() {
        this.emitEvent = null
        this.initFilter()        
      }, 

      initFilter() {

        if (this.$store.state.pages.filters.animals) {

          this.showRemoveButton = true
          this.filter = this.$cloneObject(this.$store.state.pages.filters.animals)

        } else {          

          this.showRemoveButton = false
          this.filter = {}
        }        
      },         

      onApply() {

        this.updateStore(this.filter)
        
        this.emitEvent = { event: "onApply", data: this.filter }

        this.hide()        
      },

      updateStore(filter) {

        let filters = this.$cloneObject(this.$store.state.pages.filters)

        filters.animals = filter ? this.$cloneObject(filter) : null

        this.$store.commit("pages/setFilters", filters)
      },

      onRemove() {

        this.clear()

        this.emitEvent = { event: "onRemove" }

        this.hide()      
      },

      clear() {
        this.updateStore(null)
      },
    },
  }

</script>